// extracted by mini-css-extract-plugin
module.exports = {"delay":"oMuH3xErHviZvRJlQc1Y","delayElement":"efYzHQ2b5AJVfrXCQjUa"};